module.exports = __webpack_public_path__ + "static/media/view4.bded2d4c.jpg";